import { HeaderTabs } from '.';
import { type AudiFinancingModuleSpecsFragment } from '../../../../api/fragments';
import SalesForce from '../SdmModulePage/SalesForces';
import Authorization from './Authorization';
import SalesPersonCodeMappings from './SalesPersonCodeMappings';

export type SdmModuleDetailsInnerProps = {
    activeTab: HeaderTabs;
    module: AudiFinancingModuleSpecsFragment;
};

const AudiFinancingModuleDetailsInner = ({ activeTab, module }: SdmModuleDetailsInnerProps) => {
    switch (activeTab) {
        case HeaderTabs.SalesForce:
            return <SalesForce module={module} />;

        case HeaderTabs.Authorization:
            return <Authorization module={module} />;

        case HeaderTabs.SalesPersonCodeMappings:
            return <SalesPersonCodeMappings module={module} />;

        default:
            return null;
    }
};

export default AudiFinancingModuleDetailsInner;
